import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function AgriArchDiagram() {
  return (
    <section id="arch-diagram" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading
          title="产品架构：软硬件一体化"
          subtitle="华辉数智智慧农业解决方案采用终端感知 + 网络连接 + 数据智能 + 业务应用的四层一体化架构，硬件即插即用、软件分层解耦，既可整体交付，也可按模块分期建设。"
        />

        <Reveal className="mt-12">
          <figure className="rounded-2xl border border-background-200 bg-background-50 p-3 md:p-5">
            <div className="w-full aspect-[12/7] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://static.readdy.ai/image/4482546e014370507f3d90ff31782979/ba2cecf4e8d478f184957e6782bdfadb.png"
                alt="智慧农业产品架构：软硬件一体化，展示展示层、能力层、网络层与采集层，以及 AI 数据中台、安全服务与运维服务"
                title="产品架构：软硬件一体化"
                className="w-full h-full object-contain"
              />
            </div>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}